import { type HTMLAttributes, forwardRef } from 'react';
import { Text } from '@/components/Typography';
import { cn } from '@/lib/cn';
const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('rounded-lg border bg-neutral-fill text-neutral-on-fill shadow-sm max-md:shadow-none border-neutral-muted-border', className)} {...props} />);
Card.displayName = 'Card';
const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6 max-md:pt-4 max-md:pb-3 max-md:px-4', className)} {...props} />);
CardHeader.displayName = 'CardHeader';
const CardTitle = ({
  className,
  ...props
}: HTMLAttributes<HTMLHeadingElement>) => <Text as="h3" variant="h3" className={cn('leading-none tracking-tight', className)} {...props} />;
CardTitle.displayName = 'CardTitle';
const CardDescription = ({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) => <Text as="p" variant="p" className={cn('text-muted-foreground', className)} {...props} />;
CardDescription.displayName = 'CardDescription';
const CardContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('p-6 pt-0 max-md:px-4 max-md:pb-3', className)} {...props} />);
CardContent.displayName = 'CardContent';
const CardFooter = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />);
CardFooter.displayName = 'CardFooter';
export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };